<template>
  <div class="myask">
    <div class="title">
      <h2>我的问答</h2>
    </div>
    <div class="sea">
      <ul class="filter">
        <li
          v-for="(item,index) in menuList"
          :key="index"
          @click="changPage(item)"
          :class="{'active':current==item}"
        >{{item}}
        <p></p>
        </li>
      </ul>
      <div class="mod">
        <input
        type="text"
        placeholder="请输入关键字"
        v-model="key"
      >
      <button
        class="ban"
        @click="seabtn"
      >搜索</button>
      </div>
    </div>
    
    <div class="box">
      <a-table
        :columns="columns"
        :data-source="list"
        :rowKey="record=>record.id"
        :pagination="pagination"
        @change="changePage"
        :locale="{'emptyText': '暂无数据'}"
        bordered
      >
        <!-- <div slot="tag">

            </div> -->
        <div
          slot="action"
          class="tableAction"
          slot-scope="index,record"
        >
          <span @click="todetail(record.id)">查看</span>
          <span @click="del(record.id,record.title)">删除</span>
        </div>
      </a-table>
    </div>
    <a-modal
      title="查看提问"
      :visible="askshow"
      @ok="askshow=false"
      @cancel="askshow=false"
      class="askmodel"
      okText="确认"
      cancelText="取消"
    >
      <div class="askbox">
        <p class="biaotag"><span>标题：</span><span class="titcon">{{detaillist.title}}</span></p>
        <div class="tag">
          <span>标签为：</span>
          <ul class="tagul">
            <li
              v-for="(item,index) in detaillist.tar"
              :key="index"
            >{{item}}</li>
          </ul>
        </div>
        <div class="con">
          <span>内容为：</span>
          <div class="text">{{detaillist.content}}</div>
        </div>
      </div>
    </a-modal>
    
    <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    width: 70,
  },
  {
    title: "标题",
    dataIndex: "title",
    width: 200,
  },
  {
    title: "标签",
    dataIndex: "tag",
    width:180
  },
  {
    title: "所属课程",
    dataIndex: "subject",
    width:150
  },
  {
    title: "提交时间",
    dataIndex: "subTime",
    width:100
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    width:110,
  },
];
import { getmyanswerApi, getdeleteMyAsk } from "@/request/api";
import pagination from "@/components/common/pagination";
export default {
  name: "myask",
  components:{pagination},
  data() {
    return {
      menuList: ["我的提问", "我的回答"],
      current: "",
      key: "",
      columns,
      joinshow: true,
      searchInfo: {
        type: 0,
        page: 1,
        pageSize: 10,
        courseId: "",
        keyword: "",
      },
      pagination: { total: 0, pageSize: 10 },
      list: [],
      askshow: false,
      detaillist: [],
      newId:''
    };
  },
  created() {
    this.init();
  },
   mounted() {
    let arr = window.location.pathname.split("/");
    switch (arr[arr.length - 1]) {
      case "myask":
        this.current = "我的提问";
        break;
      case "myreply":
        this.current = "我的回答";
        break;
    }
  },
  methods: {
    init() {
      this.getToken(getmyanswerApi, this.searchInfo, (res) => {
        this.list = res.data.rows.map((item, index) => ({
          "index": (this.searchInfo.page - 1) * 10 + index + 1,
          "title": item.title,
          "subject": item.course.title,
          "status": item.status,
          "tag": item.tag.join('、'),
          "tar":item.tag,
          "subTime": item.createTime,
          "id": item.id,
          "content": item.content,
        }));
        this.pagination.total = res.data.count;
        // console.log(this.list)
      });
    },
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    todetail(id) {
      this.detaillist = this.list.filter((item) => item.id == id)[0];
      this.askshow = true;
      //   console.log(this.detaillist)
    },
    del(id,title) {
      this.newId=id
      this.$confirm({
        title: `确定要删除"${title}"这个提问吗？`,
        okText: '确定',
        cancelText: '取消',
        onOk:()=>{
           this.getToken(getdeleteMyAsk, { "askId": this.newId }, (res) => {
                if (res.code == 200) {
                  this.init();
                  this.$message.success("删除成功！");
                }
          })
        },
        onCancel() {
          // console.log('Cancel');
        },
      });
    },
    changPage(data) {
      this.current = data;
      let path = "";
      switch (data) {
        case "我的提问":
          path = "/myask";
          break;
        case "我的回答":
          path = "/myreply";
          break;
      }
      this.$router.push({ path: path });
    },
    //搜索
    seabtn() {
      console.log(this.key)
      this.searchInfo.keyword = this.key;
      this.searchInfo.type = "";
      this.init();
    },
  },
};
</script>
<style >

.myask .ant-table-pagination.ant-pagination {
  text-align: center;
  margin: 0px auto;
  margin-top: 50px;
}
.askmodel .ant-btn {
  outline: 0;
  display: none;
}
.askmodel .ant-modal-footer {
  padding: 10px 16px;
  text-align: center;
  border: 0;
  border-radius: 0 0 4px 4px;
}
.askmodel .ant-modal-header {
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 0px;
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
}
.askmodel .askbox {
  margin-left: 20px;
  font-size: 16px;
  color: #333;
}
.askmodel .askbox .biaotag {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  display: flex;
}
.askmodel .askbox .biaotag span {
  width: 65px;
}
.askmodel .askbox .biaotag .titcon {
  margin-left: 20px;
  text-indent: 10px;
  width: 365px;
  margin-right: 5px;
  border: solid 1px #c5cddb;
}
.askmodel .askbox .tag {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.askmodel .askbox .tag span {
  width: 68px;
}
.askmodel .askbox .tagul {
  display: flex;
  margin-bottom: 0px;
  margin-left: 20px;
  flex-wrap: wrap;
}
.askmodel .askbox .tagul li {
  width: 80px;
  height: 38px;
  background-color: #e3f8ff;
  border: solid 1px #bfdfff;
  color: #666666;
  font-size: 14px;
  line-height: 38px;
  text-align: center;
  margin-right: 12px;
  margin-bottom: 10px;
}
.askmodel .askbox .con {
  display: flex;
}
.askmodel .askbox .con span {
  width: 65px;
}
.askmodel .askbox .text {
  flex: 1;
  border: solid 1px #c5cddb;
  text-indent: 10px;
  margin-left: 20px;
  margin-right: 20px;
}
.myask .ant-table-pagination.ant-pagination {
  text-align: center;
  margin: 0px auto;
  margin-top: 50px;
  display: none;
}
.myask .ant-table table {
  text-align: center;
}
.myask thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  text-align: center;
  font-weight: bolder;
  font-size: 14px;
}
.myask .ant-table-thead > tr > th {
    color:#333;
    font-weight: 600;
    font-size: 14px;
    /* background-color: #eaeef7; */
    height:30px;  
}
.myask .ant-table-bordered .ant-table-thead > tr > th,
.myask .ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e8e8e8;
  text-align: center;
}
.myask .ant-table-bordered .ant-table-tbody{
  background:#fff;
}
.myask .ant-table-pagination.ant-pagination {
  text-align: center;
  margin: 0px auto;
  margin-top: 50px;
  display: none;
}
.myask .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 10px 10px ;
}
</style>
<style lang="stylus" scoped>
.myask {
 margin-bottom: 100px;
  .title {
      height: 45px;
      line-height: 45px;
      overflow: hidden;
      border-bottom:1px solid #eff2f2;
      h2 {
        height:45px;
        line-height: 45px;
        margin-left: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
  }

  .sea {
    height: 45px;
    margin-left: 15px;
    display: flex;
    margin-right:30px;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    justify-content space-between
    .filter {
      display: flex;
      height: 45px;
      line-height: 45px;
      margin-top: 20px;

    li {
      width: 100px;
      margin-right: 20px;
      height: 35px;
      line-height: 35px;
      font-size: 16px;
      color: #333333;
      text-align: center;
      cursor pointer;
       p{
        width: 21px;
        height: 2px;
        background-color: #f1ce48;
        border-radius: 1px;
        text-align center;
        margin:0 auto;
        display:none
      }
    }
    li:last-child {
      margin-right: 0;
    }
    .active {
      color: #f1ce48;
      font-weight: 600;
      p{
        display:block;
      }
    }
  }
    .mod{
       input {
      outline: none;
      width: 220px;
      height: 35px;
      border: solid 1px #d4d4d4;
      text-indent: 8px;
    }
      .ban {
        outline: none;
        width: 60px;
        height: 35px;
        background-color: #f1ce48;
        color: #333;
        font-size:14px;
        cursor: pointer;
        border:0
      }
    }
  }

  
  .box {
    margin-left: 30px;
    margin-right: 30px;
    margin-top:20px;
  }

  .pagemodel {
    margin-top: 30px;
    padding-top: 30px;
  }
}
</style>
